import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const ModalWithProceed = ({ children, show, header, isLoading, close= ()=>{}, proceed = ()=>{} }) => {
  return (
    <Modal show={show} onHide={close} onRequestClose={()=>{console.log('onRequestClose')}}>
      {header?? (<Modal.Header closeButton>
        <Modal.Title>Modal heading</Modal.Title>
      </Modal.Header>)}
      
      <Modal.Body>{children}</Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={close}> Cancel </Button>
        <Button variant="primary" onClick={proceed}> Yes </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalWithProceed;
